import { render } from "./step-loan-contract.vue?vue&type=template&id=d77742aa"
import script from "./step-loan-contract.vue?vue&type=script&lang=ts"
export * from "./step-loan-contract.vue?vue&type=script&lang=ts"
script.render = render

export default script